// 手机号
export function validatePhoneNumber(rule, value, callback) {
    if (value) {
        var length = value.length;
        var phone = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (length == 11 && phone.test(value)) {
            callback()
        } else {
            callback(new Error('请填写正确的11位手机号'))
        }
    }
}

// 邮政编码
export function validateYZCode(rule, value, callback) {
    var re = /^[0-9][0-9]{5}$/g;
    if (re.test(value)) {
        callback()
    } else {
        callback(new Error('请填写正确的邮政编码'))
    }
}

//电话号码验证
export function validateTel(rule, value, callback) {
    var tel = /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
    if (tel.test(value)) {
        callback()
    } else {
        callback(new Error('请填写正确的座机号码'))
    }
}

// 传真号码
export function validateFax(rule, value, callback) {
    var tel = /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/g; //区号3,4位,号码7,8位
    if (tel.test(value)) {
        callback()
    } else {
        callback(new Error('请填写正确的传真号码'))
    }
}

// 电话号码验证
export function validateTelOrPhone(rule, value, callback) {
    var tel = /(^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?$)|(^0?[1][358][0-9]{9}$)/;
    if (tel.test(value)) {
        callback()
    } else {
        callback(new Error('请填写正确的电话号码'))
    }
}

// 数字校验
export function validateNumber(rule, value, callback) {
    var num = /(^[\-0-9][0-9]*(.[0-9]+)?)$/;
    if (num.test(value)) {
        callback()
    } else {
        callback(new Error('请输入正确的数字'))
    }
}

//验证编号位置 
export function validateTwoLimit(rule, value, callback) {
    var regExp = /^\-?\d{1,12}([.]\d{1,2})?$/;
    if (regExp.test(value)) {
        callback()
    } else {
        callback(new Error('最多填写两位小数'))
    }
}

// 2位小数和数字结合
export function validateTwoNumer(rule, value, callback) {
    var regExp = /^\-?\d{1,12}([.]\d{1,2})?$/;
    var num = /(^[\-0-9][0-9]*(.[0-9]+)?)$/;
    if (!num.test(value)) {
        callback(new Error('请输入正确的数字'))
    } else if (!regExp.test(value)) {
        callback(new Error('最多填写两位小数'))
    } else {
        callback()
    }
}

//验证编号位置
export function isNumberlength(rule, value, callback) {
    var length = value.length;
    if (length >= 2) {
        callback()
    } else {
        callback(new Error('请填写正确的2位或2位以上编号'))
    }
}

//验证知识产权
export function validateIsiprNumber(rule, value, callback) {
    //修改正则表达式 可包含NIP
    var ipr = /^(NIP)?[0-9]*$/;
    if (ipr.test(value)) {
        callback()
    } else {
        callback(new Error('编号只允许输入数字，按照（01、02......）格式填写！'))
    }
}

// 正整数
export function validateNumbers(rule, value, callback) {
    var num = /(^[0-9]\d*$)/;
    if (num.test(value)) {
        callback()
    } else {
        callback(new Error('请输入正确整数'))
    }
}